import { Printer, Receipt, FileText, ChefHat } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "../../../../components/ui/dropdown-menu";
import { statusConfig, getNormalizedStatus } from "../../lib/pedidoConstants";
import { formatDateTime } from "../../lib/pedidoFormatters";

/**
 * Header do popup: código, badge de status, badge de módulo (opcional), caixa,
 * data e dropdown Imprimir (só renderiza se onReprint for fornecido).
 */
export function PedidoDetailHeader({ pedido, moduloBadge, onReprint }) {
  const sCfg = statusConfig[getNormalizedStatus(pedido.status)] || {};
  const isMesa = pedido.modulo === "Mesas" || pedido.mesa_id;

  return (
    <div className="flex items-center gap-2 px-4 py-3 border-b shrink-0">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-mono text-lg font-bold">{pedido.codigo || "#-----"}</span>
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${sCfg.color || ""}`}>
            {sCfg.label || pedido.status}
          </span>
          {moduloBadge}
          {pedido.caixa_id && (
            <span className="text-[10px] text-orange-600 dark:text-orange-400 font-medium">
              Cx#{pedido.caixa_id}
            </span>
          )}
        </div>
        <p className="text-xs text-muted-foreground mt-0.5">{formatDateTime(pedido.created_at)}</p>
      </div>
      {onReprint && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="p-2 rounded-md hover:bg-muted transition-colors mr-6" title="Imprimir 2ª via">
              <Printer className="w-5 h-5 text-muted-foreground" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            {isMesa ? (
              <DropdownMenuItem onClick={() => onReprint(pedido)}>
                <Receipt className="w-4 h-4 mr-2" /> Cupom Fechamento
              </DropdownMenuItem>
            ) : (
              <>
                <DropdownMenuItem onClick={() => onReprint(pedido, "ambos")}>
                  <Printer className="w-4 h-4 mr-2" /> Ambos
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => onReprint(pedido, "entrega")}>
                  <FileText className="w-4 h-4 mr-2" /> Entrega
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => onReprint(pedido, "preparo")}>
                  <ChefHat className="w-4 h-4 mr-2" /> Preparo
                </DropdownMenuItem>
              </>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
